<template>
  <v-row no-gutters>
    <v-col cols="12">
      <div class="primary--text text-left text-body-2">
        Cliente: {{ data.NombreCli }}
      </div>
    </v-col>
    <v-col cols="6">
      <v-card flat tile>
        <div class="text-left text-body-2">
          {{ data.Descrip }}
        </div>
       
        <div class="text-left text-body-2">
          Código Cliente: {{ data.CodigoCli }}
        </div>
        <div class="text-left text-body-2">RIF: {{ data.RIF }}</div>
        <div class="text-left text-body-2">
          Cond Pago: {{ data.CondicionPago }}
        </div>
       
      </v-card>
    </v-col>
    <v-col cols="6">
      <v-card flat tile> 
        <div class="text-left text-body-2">Estatus: {{ data.StatusPed }}</div>
        <div class="text-left text-body-2">
          Fecha Pedido: {{ data.FechaPedido }}
        </div>
        <div class="text-left text-body-2">
          Fecha Vence: {{ data.FechaVencimiento }}
        </div>
        <div class="text-left text-body-2">Tipo: {{ data.TipoPedido }}</div>
       
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    data: Object,
  },
};
</script>
